import { type User } from '@kalos/kalos-rpc';
import { FileTextIcon } from '@radix-ui/react-icons';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useState } from 'react';

import { useSchedulerStyle } from '../../context/schedulerStyle';
import { InternalNoteFormattedText } from './InternalNoteFormattedText';

interface ReviewInternalNoteProps {
  customer: User;
}

export const ReviewInternalNote = ({ customer }: ReviewInternalNoteProps) => {
  const [expanded, setExpanded] = useState(false);
  const intNotes = customer.intNotes || '';
  const compact = useSchedulerStyle();

  if (!compact) {
    return (
      <div className="rounded-lg border border-gray-200 bg-white p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1.5">
            <FileTextIcon className="h-3.5 w-3.5 text-gray-500" />
            <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">
              Internal Note
            </p>
          </div>
          {intNotes && (
            <button
              type="button"
              onClick={() => setExpanded(!expanded)}
              className="rounded p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
            >
              {expanded ? (
                <ChevronUp className="h-3.5 w-3.5" />
              ) : (
                <ChevronDown className="h-3.5 w-3.5" />
              )}
            </button>
          )}
        </div>
        {intNotes ? (
          <div className="mt-2 rounded-md border border-gray-200 bg-gray-50 p-2 text-sm">
            <InternalNoteFormattedText
              text={intNotes}
              className={`leading-relaxed ${expanded ? '' : 'line-clamp-3'}`}
            />
          </div>
        ) : (
          <p className="mt-2 text-sm text-gray-400">No internal note set</p>
        )}
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
      <div className="flex items-center justify-between bg-gray-50 px-4 py-2.5">
        <button
          type="button"
          onClick={() => setExpanded(!expanded)}
          className="flex flex-1 items-center gap-1.5 text-left"
        >
          <FileTextIcon className="h-3.5 w-3.5 text-gray-500" />
          <p className="text-[10px] font-semibold uppercase tracking-[0.5px] text-gray-400">
            Internal Note
          </p>
        </button>
        <button
          type="button"
          onClick={() => setExpanded(!expanded)}
          className="rounded p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
        >
          {expanded ? (
            <ChevronUp className="h-3.5 w-3.5" />
          ) : (
            <ChevronDown className="h-3.5 w-3.5" />
          )}
        </button>
      </div>
      {expanded &&
        (intNotes ? (
          <div className="px-4 py-3 text-xs text-gray-700">
            <InternalNoteFormattedText text={intNotes} className="leading-relaxed" />
          </div>
        ) : (
          <p className="px-4 py-3 text-xs text-gray-400">No internal note set</p>
        ))}
    </div>
  );
};
